import _ from 'lodash'
import React from 'react'
import Slider from 'react-slick'
import { isToday, format } from 'date-fns'
import CarouselArrow from './carouselArrow'
import ScheduleItem from './scheduleItem'

import 'slick-carousel/slick/slick.css'
import './slick-theme.css'
import './style.scss'

class ScheduleCarousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.type === 'person' ? props.data.contentData : props.data && props.data.contentData.filter(item => item.gist.scheduleEndDate > Date.now()),
      currentItem: 0,
      isMobile: window.innerWidth <= 1025
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.currentItem === nextState.currentItem && this.state.isMobile === nextState.isMobile) {
      return false
    }
    return true
  }

  componentDidMount() {
    this.setState({
      innerWidth: window.innerWidth,
      scheduleCarousel: document.querySelector(
        ".schedule-carousel-container"
      )
    });

    if (this.props.type !== 'person' && this.state.items.length > 0) {
      this.interval = setInterval(this.moveSlider, 4000)
      this.scheduleCarousel = document.querySelector(".schedule-carousel-container");
      setTimeout(() => {
        const slickTrack = this.scheduleCarousel.querySelector(".slick-track")
        const width = slickTrack.children[0].offsetWidth
        slickTrack.style.transform = `translate3d(-${(this.state.currentItem + 2) * width}px, 0, 0)`
      }, 0);
    }
    window.addEventListener('resize', () => { this.setState({ isMobile: window.innerWidth <= 1025 }) }, false)
  }

  componentWillMount() {
    clearInterval(this.interval)
  }

  moveSlider = (i) => {
    if (this.Slider === null) return;
    if (typeof i === 'number') {
      this.setState({
        currentItem: i
      })
      this.state.isMobile ? this.Slider.slickGoTo(i) : this.Slider.slickGoTo(i + 1);
      clearInterval(this.interval)
      this.interval = setInterval(this.moveSlider, 4000);
      return
    }
    if (this.state.currentItem + 1 !== this.state.items.length) {
      this.state.isMobile ? this.Slider.slickGoTo(this.state.currentItem + 1) : this.Slider.slickGoTo(this.state.currentItem + 2)
      this.setState({
        currentItem: this.state.currentItem + 1
      })
    } else {
      this.setState({ currentItem: 0 });
      this.state.isMobile ? this.Slider.slickGoTo(0) : this.Slider.slickGoTo(1)
    }
  }


  render() {
    const hasMultipleItems = this.state.items && this.state.items.length > 1;
    const timeDelay = (_.get(this.props.layout, 'settings.timeDelay')) * 1000;
    if (this.state.items.length === 0) {
      return <div></div>
    }

    //const width = this.state.scheduleCarousel && `${this.state.scheduleCarousel.offsetWidth - 30}px`
    return <div className="schedule-carousel-container">
      {this.props.type !== "person" && <div className="schedule">
        <div className="live-games">
          <p>Live and UpComing</p>
        </div>
        <div className="schedules-container">
          <div className="schedules">
            {this.state.items.map((item, i) => {
              const dayText = isToday(item.gist.scheduleStartDate) ? "Today" : format(item.gist.scheduleStartDate, "ddd")
              return <div className={`day-time ${this.state.currentItem === i ? " current" : ""}`} key={i} onClick={this.moveSlider.bind(this, i)}>
                <p className="day">
                  <span className="day-text"> {dayText} </span>
                  <span className="start-text">
                    {format(item.gist.scheduleStartDate, "h:mm A")}
                  </span>
                </p>
              </div>;
            })}
          </div>
        </div>
      </div>}
      <div className={`carousel ` + (_.get(this.props, "layout.settings.isHidden") ? "hide" : "")}>
        {this.state.items && this.state.items.length > 0 &&
          <Slider
            variableWidth={!this.state.isMobile && true}
            ref={Slider => (this.Slider = Slider)}
            infinite={true}
            speed={750}
            autoplay={this.props.type === 'person'}
            autoplaySpeed={timeDelay}
            arrows={this.props.type === 'person' && hasMultipleItems}
            dots={this.props.type === 'person' && hasMultipleItems}
            nextArrow={this.props.type === "person" && <CarouselArrow itemCount={this.state.items.length} />}
            prevArrow={this.props.type === "person" && <CarouselArrow itemCount={this.state.items.length} />}>
            {this.state.items.map((item, i) => <div key={i}>
              <ScheduleItem item={item} maxWidth={this.state.innerWidth} />
            </div>)
            }
          </Slider>}
      </div>
    </div>
  }
}

export default ScheduleCarousel;

